module.exports = __webpack_public_path__ + "img/c6bb8ec4ce9bb7eee59fb54a8f391d07.2a400ec6.png";